import { Component, Input } from '@angular/core';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';

@Component({
  selector: 'app-form-predibattimento-view',
  templateUrl: './form-predibattimento-view.component.html',
  styleUrls: ['./form-predibattimento-view.component.css']
})
export class FormPredibattimentoViewComponent {
  labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;

  @Input() ctxBodyFascicolo;
  constructor() {}
}
